import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import { CustomButton } from '@components/Pages/ErrorPage/ErrorPage.styled';
import { PromptBar } from '@components/Utils/SessionExpiredPrompt/SessionExpiredPrompt';

// "A new version of Attender is available" - shown when useVersionCheck finds a newer build live
// while the user is actively on the page, so the reload is theirs to choose (nothing typed is lost).
// Gives way to the session-expired prompt, which matters more and sits in the same spot.
export const NewVersionPrompt = () => {
  const i18n = useI18n();
  const { newVersionAvailable, sessionExpired } = useStore();

  if (!newVersionAvailable || sessionExpired) return null;

  return (
    <PromptBar role="status" tone="info">
      <p>{i18n.t('new-version-text')}</p>
      <CustomButton
        small={true}
        mobile={true}
        onClick={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
      >
        {i18n.t('new-version-button')}
      </CustomButton>
    </PromptBar>
  );
};

export default NewVersionPrompt;
